import { DateInput, type DateInputProps } from "swing-components";

import styles from "./SchoolYears.module.css";

type SchoolYearFieldProps = {
  label: string;
  isEditing: boolean;
} & DateInputProps;

export function SchoolYearField(props: SchoolYearFieldProps) {
  const { value, label, isEditing, ...rest } = props;

  return (
    <li className={styles.schoolFieldListItem}>
      <p css={{ fontWeight: 500 }}>{label}</p>
      {isEditing ? <DateInput value={value} {...rest} /> : <DateInput value={value} isReadOnly />}
    </li>
  );
}
